import { render } from "./DropdownDivider.vue?vue&type=template&id=451badb6"
const script = {}

import exportComponent from "/home/atsuser/aos/aos-ats-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__